import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


export default () => 

    <div className="sticky-inner">

    <h1>Abhinav Namballa</h1>

    
    <ul>
    <li className="social" ><a href="https://twitter.com/abhinamballa" target="_blank"><FontAwesomeIcon className="tech-icon" icon={['fab', 'twitter']} size="lg" /> @AbhiNamballa</a></li>
    <li className="social"><a href="https://github.com/Abhinavnamballa" target="_blank"><FontAwesomeIcon className="tech-icon" icon={['fab', 'github']} size="lg"/> /AbhinavNamballa</a></li>
    <li className="social"><a href="https://www.linkedin.com/in/abhinav-namballa/" target="_blank"><FontAwesomeIcon className="tech-icon" icon={['fab', 'linkedin']} size="lg"/> /AbhinavNamballa</a></li>
    </ul>
    
  
    </div>;